import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h2 className="text-primary mb-4">Privacy Policy</h2>
          <p>
            Neinus Technologies values your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, and disclose your information.
          </p>
          <h3 className="text-dark">Information We Collect</h3>
          <p>We may collect the following types of information:</p>
          <ul>
            <li><strong>Personal Identification Information:</strong> Name, email address, phone number, etc.</li>
            <li><strong>Technical Data:</strong> IP address, browser type and version, time zone setting, and location.</li>
            <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
          </ul>
          <h3 className="text-dark">How We Use Your Information</h3>
          <p>
            Neinus Technologies uses your information for various purposes, including to provide and maintain our services, notify you about changes to our services, allow you to participate in interactive features of our website, provide customer support, monitor the usage of our website, and detect, prevent and address technical issues.
          </p>
          <h3 className="text-dark">Sharing Your Information</h3>
          <p>
            We may share your information with service providers, or in response to legal requirements, Neinus Technologies may disclose your personal data if required to do so by law or in response to valid requests by public authorities.
          </p>
          <h3 className="text-dark">Cookies and Tracking Technologies</h3>
          <p>
            We use cookies and similar tracking technologies to track the activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </p>
          <h3 className="text-dark">Data Security</h3>
          <p>
            We strive to use commercially acceptable means to protect your personal data. However, no method of transmission over the internet or method of electronic storage is 100% secure, and we cannot guarantee its absolute security.
          </p>
          <h3 className="text-dark">Your Data Protection Rights</h3>
          <p>
            You have the right to access, rectify, erase, restrict processing, and data portability, subject to certain conditions. You can exercise these rights by contacting us at the details provided below.
          </p>
          <h3 className="text-dark">Changes to This Privacy Policy</h3>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
          </p>
          <h3 className="text-dark">Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
            <ul>
              <li><strong>Email:</strong> contactus@neinus.com</li>
              <li><strong>Phone:</strong> +91 7200864223 , +91 7200864623</li>
                  <li><strong>Address:</strong> Neinus Technologiees
                  <p><strong> Sathyamangalam: </strong> No 139/1A,Kamadhenu Nagar, Opposite To BIT College , Sathy Athani Road Bus Stop, Sathyamangalam - 638503 , Erode Dt, TamilNadu <br/>
                  <strong className='text-primary fw-bold'> +91 7200864223, +91 7200864623, +91 9965618507</strong> <br/>
                  
                  </p>
                          </li>
            </ul> 
          </p>  
    </div>
  );
}

export default PrivacyPolicy;
